import { Group, Image, List, ListItem, Stack, Text, Title } from '@mantine/core'
import { TwContainer } from '@/lib/components/TwContainer'

export const StiSectionTwo = () => {
	return (
		<section>
			<TwContainer className={'justify-center py-16 pt-32 gap-12'} column>
				<Group gap={0} justify={'space-around'}>
					<Image
						loading={'lazy'}
						className={'order-last md:order-first md:max-w-3xl max-w-xs rounded-[32px]'}
						src={'/images/img_18.webp'}
						w={520}
						h={520}
						alt={'Why Choose PrEP at Wellview Care?'}
					/>
					<Stack className={'max-w-xl p-8'} gap={'xs'}>
						<Title variant={'title2'}>
							Why Choose PrEP <br />
							at Wellview Care?
						</Title>
						<Text variant={'gray'} ta={'left'}>
							At Wellview Care, your well-being is our top priority. Here's why you should choose us for all your STI and STD-related needs
						</Text>
						<List type={'ordered'} spacing={'lg'}>
							<ListItem>
								<strong>Expertise:</strong> Our experienced medical professionals specialize in STI and STD testing, diagnosis, and treatment. We stay
								updated with the latest developments in sexual health to provide you with the best care.
							</ListItem>
							<ListItem>
								<strong>Confidentiality:</strong> We respect your privacy and ensure that all interactions, test results, and personal information are
								kept strictly confidential. Your privacy is of utmost importance to us.
							</ListItem>
							<ListItem>
								<strong>Cutting-Edge Testing:</strong> We utilize state-of-the-art testing methods to provide accurate and timely results. Your health
								and safety are our primary concerns.
							</ListItem>
							<ListItem>
								<strong>Counseling and Support:</strong> We offer comprehensive counseling services to address your concerns, answer your questions,
								and provide guidance throughout the testing and treatment process. We are here to support you at every step.
							</ListItem>
						</List>
					</Stack>
				</Group>
			</TwContainer>
		</section>
	)
}
